export enum PublishingMode
{
    ByInvitationOnly = 0,
    DeployToTargetGroup = 1,
    PublishToCatalogue = 2,
    PublishToSubscribers = 3
}
